module.exports = __webpack_public_path__ + "img/company_video_img.25d5e32a.jpg";